import { useCallback, forwardRef, useContext } from 'react';
import { getDeliveryIdentifierType, getRecipientFieldName, getRecipientKey } from 'conversations-thread-data/channel-configuration/public/operators';
import { getAllRecipientsRemoved, getRecipientAdded, getRecipientRemoved
// TODO: move to composer-ui
} from '../../../usage-tracking/events/metadataEditorInteractions';
import { getCommonMessage } from 'conversations-thread-data/common-reply/public/operators/commonReplyGetters';
// @ts-expect-error module not typed
import { setCommonMessage } from 'conversations-thread-data/common-reply/public/operators/commonReplySetters';
import { updateGenericRecipientField } from 'conversations-thread-data/common-reply/public/operators/updateRecipientField';
import RecipientField from './RecipientField';
import { EditorTrackerContext } from '../../../usage-tracking/context/EditorTrackerContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const logRecipientChange = (nextRecipients, prevRecipients, recipientType, trackEvent) => {
  recipientType = recipientType.toLowerCase();
  if (nextRecipients.size === 0) {
    trackEvent(getAllRecipientsRemoved({
      recipientType
    }));
  } else {
    if (nextRecipients.size > prevRecipients.size) {
      trackEvent(getRecipientAdded({
        recipientType
      }));
    } else if (nextRecipients.size < prevRecipients.size) {
      trackEvent(getRecipientRemoved({
        recipientType
      }));
    }
  }
};
const _Recipient = (props, ref) => {
  const {
    allRecipients,
    delayedExpanded,
    handleSetExpanded,
    inboxId,
    index,
    isComposer,
    recipientField,
    recipientFieldsExpansionState,
    subfieldAutofocus,
    toLabel,
    onChange,
    reply
  } = props;
  const fieldName = getRecipientFieldName(recipientField);
  const recipientKey = getRecipientKey(recipientField);
  const {
    trackEvent
  } = useContext(EditorTrackerContext);
  const valueChangeHandler = useCallback(nextRecipients => {
    const commonMessage = getCommonMessage(reply);
    const updatedMessage = commonMessage && fieldName ? updateGenericRecipientField(fieldName, nextRecipients, commonMessage) : commonMessage;

    // Update the reply
    const replyWithRecipients = setCommonMessage(updatedMessage, reply);
    onChange(replyWithRecipients);
    if (recipientKey) {
      const recipientsForKey = allRecipients.get(recipientKey);
      logRecipientChange(nextRecipients, recipientsForKey, recipientKey, trackEvent);
    }
  }, [onChange, reply, allRecipients, recipientKey, fieldName, trackEvent]);
  const deliveryIdentifier = getDeliveryIdentifierType(recipientField);
  return /*#__PURE__*/_jsx(RecipientField, {
    allRecipients: allRecipients,
    delayedExpanded: delayedExpanded,
    deliveryIdentifier: deliveryIdentifier,
    fieldName: fieldName,
    handleSetExpanded: handleSetExpanded,
    inboxId: inboxId,
    index: index,
    isComposer: isComposer,
    recipientFieldsExpansionState: recipientFieldsExpansionState,
    recipientKey: recipientKey,
    reply: reply,
    subfieldAutofocus: subfieldAutofocus,
    toLabel: toLabel,
    valueChangeHandler: valueChangeHandler,
    ref: ref
  }, recipientKey);
};
_Recipient.displayName = '_Recipient';
export const Recipient = /*#__PURE__*/forwardRef(_Recipient);